import React, {Component} from "react";

import {
    Image,
    Platform,
    StyleSheet,
    TouchableHighlight, TouchableOpacity,
    View
} from "react-native";

import {moderateScale} from "../../tools/Scaling";
import HMTextView from "../../customviews/HMTextView";
import DeviceInfo from "react-native-device-info";
import {Tools} from "../../tools/Tools";

import i18n from '../../I18n/i18n.js';
import * as Colors from "../../tools/Colors";
import HMButton from "../HMButton";
import PathFile from "../../assets/PathFile";
import connect from "react-redux/es/connect/connect";

export class DialogUpdateAppCustomize extends Component {
    state = {
        showDialog: true
    };

    constructor(props) {
        super(props);

     /*   if (store.getState().reducerSplashGetAllData.resultsSaina != null) {

        }*/


    }

    render() {
        const {selfStyle, titlee, textt, onPressCancel, onPressOK, numberOfLines, data} = this.props;
        //let v=Constant.NameApp;
        let DataSplashScreen = (this.props.DataSplashScreen?.resultsSaina) ? this.props.DataSplashScreen.resultsSaina.result.info : (this.props.DataSplashScreen?.resultsShahrdar ? this.props.DataSplashScreen.resultsShahrdar.result.info : null)
        let DataSplasSatiahScreen = (this.props.DataSplasSatiahScreen?.results) ? this.props.DataSplasSatiahScreen.results.info : null

        let DataSplash = DataSplashScreen ? DataSplashScreen : (DataSplasSatiahScreen ? DataSplasSatiahScreen : null);
        let checkVersion = DataSplash ? (Platform.OS === 'ios' ? DeviceInfo.getBuildNumber() < DataSplash.ios.version : DeviceInfo.getVersion() < DataSplash.android.version) : null
        let checkVersion_force = DataSplash ? (Platform.OS === 'ios' ? DeviceInfo.getBuildNumber() < DataSplash.ios.version_force : DeviceInfo.getVersion() < DataSplash.android.version_force) : null

        return (

            (this.state.showDialog || checkVersion_force) && Platform.OS !== "web" ?
                <TouchableHighlight
                    style={[
                        checkVersion || checkVersion_force ?
                            {
                                position: 'absolute',
                                width: '100%',
                                height: '100%',
                                alignContent: 'center',
                                alignItems: 'center',
                                justifyContent: 'center',

                                // height:"100%",
                                // width:"100%",

                                top: 0,
                                bottom: 0,
                                right: 0,
                                left: 0,
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                zIndex: 9900
                            }
                            : {height: 0, width: 0}
                    ]} onPress={() => {

                    this.setState({
                        showDialog: false
                    })
                }}>
                    {
                        checkVersion || checkVersion_force ?
                            <View style={styles.modalDialog}>

                                <View style={{

                                    justifyContent: "center",
                                    alignItems: "center",
                                    backgroundColor: Colors.white,
                                    width: '100%'
                                }}>
                                    <Image source={PathFile.image.logo}
                                           style={{
                                               width: moderateScale(100),
                                               height: moderateScale(80),
                                               resizeMode: "contain"
                                           }}/>


                                    <HMTextView type={"bold"} style={{
                                        fontSize: moderateScale(14),
                                        color: Colors.blackLight,
                                        marginTop: moderateScale(10)
                                    }}
                                        //text={Constant.NameApp}
                                                text={i18n.t('constant.Old_version') + '"' + `${i18n.t('appName')}` + '"' + i18n.t('constant.DescUpdate')}


                                    />
                                    <HMButton


                                        text={i18n.t('constant.Update')}
                                        onPress={() => Tools.GoLink_AI(DataSplash.ios.link, DataSplash.android.link)}
                                        // textStyle={{color: "white", fontSize: moderateScale(14)}}
                                        style={styles.buttonShowStyle}
                                        // backgroundColor={Colors.colorPrimaryDark}
                                    />
                                </View>


                            </View>
                            :
                            <View/>
                    }


                </TouchableHighlight>
                :
                null


        );
    }
}
const mapStateToProps = state => {
    return {
        // data: state.reducerSplashGetAllData,
        // NoInternetDialogSet: state.reducerMenuScreen.NoInternetDialogSet,
        // showLoadingSet: state.reducerMenuScreen.showLoadingSet,
        // resultsSetCommentScreen: state.reducerMenuScreen.resultsSetCommentScreen,
        // token: state.reducerSplashGetAllData.token,
        DataSplashScreen: state.reducerSplashGetAllData,
        DataSplasSatiahScreen: state.reducerSplashSatiaScreen,

    };
};
const mapDispatchToProps = dispatch => {
    return {}
};
export default connect(mapStateToProps, mapDispatchToProps)(DialogUpdateAppCustomize);

const styles = StyleSheet.create({
    modalBackDrop: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

        // height:"100%",
        // width:"100%",

        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
        zIndex: 9900
    },
    modalDialog: {
        backgroundColor: "white",
        width: '85%',

        alignItems: 'center',
        justifyContent: 'center',
        padding: moderateScale(15),
        //    flex:1,

        // height: moderateScale(185),
        borderRadius: moderateScale(1),
        marginHorizontal: moderateScale(10),
    },
    modalLoading: {
        textAlign: "center",
    },

    modalTextTitle: {
        fontSize: moderateScale(16),
        color: 'black',
        //  fontFamily: "IRANSansMobile",
        justifyContent: 'center',
        textAlign: 'center',
        fontWeight: 'bold'
    },
    modalTextDescription: {
        fontSize: moderateScale(14),
        // fontFamily: "IRANSansMobile",
        color: 'black',
        margin: 10
    },
    modalVeiwOk: {
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',

    },
    modalTextName: {
        fontSize: moderateScale(16),
        color: 'black',
        // fontFamily: "IRANSansMobile",
        marginTop: moderateScale(6),
        marginBottom: moderateScale(6)
    },
    modalTextDesc: {
        fontSize: moderateScale(14),
        color: 'black',
        //fontFamily: "IRANSansMobile",
    },
    buttonShowStyle: {
        padding: moderateScale(10),
        width: '100%',
        marginLeft: moderateScale(6),
        borderRadius: moderateScale(4),
        marginTop: moderateScale(10)

    }, buttonCancelStyle: {
        padding: moderateScale(10),
        width: '100%',
        marginRight: moderateScale(6),
        borderRadius: moderateScale(4),
    }
});
